import "./index.css";
import useOffcanvasStore from "store/offcanvasStore";

const ExpandableButton = (props) => {
    const { title, icon, formId, offcanvasProps={} } = props;
    const { openOffcanvas } = useOffcanvasStore();

    return (
        <div className="justify-content-end d-flex position-relative">
            <button
              className="second-step btn btn-app expand-btn"
              type="button"
              onClick={() => openOffcanvas(formId, offcanvasProps)}>
              <i className={`fs-2 ms-2 ${icon}`}></i>
              <span className="fs-3 ms-3 text-nowrap fw-bold button-text">
                {title}
              </span>
            </button>
        </div>
    )
}

export default ExpandableButton;